module.exports = __webpack_public_path__ + "static/img/antro.a1b84de1.svg";